import { SelectSearcher } from "../../../../_components/Abstractions/MultiSearcher/SelectSearcher";
import { useWeightDifferenceSearch } from "./WeightDifferenceSearcher";

export function WeightDifferenceSelect({ name, saveWholeObject }) {
  const { items, onSearchChange } = useWeightDifferenceSearch();

  return (
    <SelectSearcher
      name={name}
      items={items}
      onSearchChange={onSearchChange}
      optionsObject={{ key: "weightDifferenceId", value: "name" }}
      label="Różnica w wadze"
      saveWholeObject={saveWholeObject}
    />
  );
}
